<style>
    .page-item {
        cursor: pointer;
    }
    h4 {
        text-transform: capitalize;
    }
</style>

<template>
    <div class="main-content">
        <section class="section">
            <div class="section-header">
                <h1>Laporan Produk</h1>
                <div class="section-header-breadcumb button">
                    <a href="javascript:" @click.prevent="goTo('/laporan/produk/daftar-produk')" class="btn btn-icon icon-left btn-primary mr-1"><i class="fa fa-dollar"></i> Ringkasan Produk</a>
                    <a href="javascript:" @click.prevent="goTo('/laporan/produk/rincian-persediaan')" class="btn btn-icon icon-left btn-info mr-1"><i class="fas fa-cube"></i> Rincian Persediaan</a>
                </div>
            </div>
            <div class="section-body">
                <div class="row">
                    <div class="col-12">
                        <div class="card">
                            <div class="card-header">
                                <h4 style="text-tranform:capitalize;">{{ url[0] }} {{ url[1] }}</h4>
                                <div class="card-header-form">
                                    <div class="input-group">
                                        <label class="mr-1 font-weight-bold">Tanggal Mulai</label>
                                        <vc-date-picker v-model="tanggal_mulai" :input-props='{class: "form-control",placeholder: "Tanggal Mulai",style:"display:inline;"}'/>
                                        <div class="input-group-btn mr-3">
                                            <button class="btn btn-primary"><i class="fa fa-calendar"></i></button>
                                        </div>
                                        <label class="mr-1 font-weight-bold">Tanggal Selesai</label>
                                        <vc-date-picker v-model="tanggal_selesai" :input-props='{class: "form-control",placeholder: "Tanggal Selesai",style:"display:inline;"}'/>
                                        <div class="input-group-btn mr-4">
                                            <button class="btn btn-primary"><i class="fa fa-calendar"></i></button>
                                        </div>
                                        
                                        <button @click="setFilter()" class="btn btn-outline-primary mr-3">Filter</button>
                                        <a :href="siteUrl+'Laporan/exportExcel/produk?tanggal_mulai='+formatDate(tanggal_mulai)+'&tanggal_selesai='+formatDate(tanggal_selesai)+'&tipe='+url[0]+'-'+url[1]" target="_blank" style="padding:7px 0px 0px 0px" class="btn btn-outline-info"><i class="fa fa-file-excel-o"></i> Export to Excel</a>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body p-0">
                                <div v-if="url[1] == 'produk'" class="table-responsive">
                                    <table class="table table-hover table-bordered table-md">
                                        <thead>
                                            <tr>
                                               <th>#</th>
                                                <th></th>
                                                <th>Kode Produk</th>
                                                <th>Nama Produk</th>
                                                <th>Qty</th>
                                                <th>Unit</th>
                                                <th>Harga Beli/Produksi</th>
                                                <th>Harga Beli/Produksi Rata2</th>
                                                <th>Harga Jual Rata2</th>
                                                <th>Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr style="cursor:pointer;" v-for="list in produkList" v-bind:key="list.main.id_produk" @click="goDetail(list.main.id_produk)">
                                                <td>{{ list.no }}</td>
                                                <td></td>
                                                <td>{{ list.main.kode_produk }}
                                                    <table style="min-width:1px !important" v-if="list.alias != null">
                                                        <tr style="background-color:inherit" v-for="alias in list.alias" v-bind:key="alias.id_alias">
                                                            <td style="color: #acb5f6;">
                                                            {{ alias.kode_alias }}
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                                <td><i v-if="list.main.is_produksi == '1'" class="fas fa-flask" style="color:#8B008B"></i>  &nbsp; {{ list.main.nama_produk }}
                                                    <table style="min-width:1px !important" v-if="list.alias != null">
                                                        <tr style="background-color:inherit" v-for="alias in list.alias" v-bind:key="alias.id_alias">
                                                            <td style="color: #acb5f6;">
                                                            {{ alias.nama_alias }}
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                                <td>{{ list.qty }} <span v-if="list.dipesan != 0">({{ list.dipesan }})</span> </td>
                                                <td>{{ list.main.nama_satuan }}</td>
                                                <td>{{ 'Rp. '+ $parent.currencyFormat(list.main.harga_beli) }}</td>
                                                <td>{{ 'Rp. '+ $parent.currencyFormat(list.harga_beli) }}</td>
                                                <td>{{ 'Rp. '+ $parent.currencyFormat(list.harga_jual) }}</td>
                                                <td>{{ 'Rp. '+ $parent.currencyFormat(list.nilai_total) }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div v-else-if="url[1] == 'persediaan'" class="table-responsive">
                                    <rincian-table :dataList="produkList"></rincian-table>
                                </div>
                            </div>
                            <div class="card-footer text-right">
                                <nav class="d-inline-block">
                                    <ul class="pagination mb-0">
                                        <li class="page-item disabled">
                                            <a class="page-link" href="#" tabindex="-1"><i class="fas fa-chevron-left"></i></a>
                                        </li>
                                        <li v-for="pages in pagination" v-bind:key="pages" class="page-item" :class="{ active: pages == page}">
                                            <span class="page-link" @click="tableTo(pages)">{{ pages }}</span>
                                        </li>
                                        <li class="page-item">
                                            <a class="page-link" href="#"><i class="fas fa-chevron-right"></i></a>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import Vue from 'vue'
import VModal from 'vue-js-modal'
import RincianTable from './TableRincian.vue'

Vue.use(VModal)

export default {
    data() {
        return {
            produkList : [],
            perPage: 10,
            page: 1,
            search: '',
            maxPagination: 5,
            first: 1,
            last: '',
            totalRow: '',
            pagination: [],
            url : '',
            filter : '',
            tanggal_mulai : '',
            tanggal_selesai : '',
            siteUrl : window.location.href.substr(0, window.location.href.indexOf('#')),
        }
    },
    mounted() {
        this.url = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
        this.url = this.url.split('-');    
        this.init();
    },
    methods: {
        init: function() {
            if(this.url[1] == 'produk') {
                this.$root.is_loading = true;
                this.$http.get("Laporan/getDaftarProduk?perPage="+this.perPage+"&page="+this.page+"&search="+this.filter+"&tanggal_mulai="+this.formatDate(this.tanggal_mulai)+"&tanggal_selesai="+this.formatDate(this.tanggal_selesai)).then(result => {
                    if(result.data.code == '00') {
                        alert('failed get Produk')
                    }
                    else {
                        this.produkList = result.data.detail.data;
                        this.totalRow = result.data.detail.totalRow;
                        this.last = Math.ceil(this.totalRow / this.perPage)
                        this.pagination = this.getPaging();
                    }
                    this.$root.is_loading = false;
                }, error => {
                    this.$root.is_loading = false;
                    console.log('gk ok')
                    context.errors = errors;
                });
            }else if(this.url[1] == 'persediaan') {
                this.$root.is_loading = true;
                this.$http.get("Laporan/getRincianPersediaanProduk?perPage="+this.perPage+"&page="+this.page+"&search="+this.filter+"&tanggal_mulai="+this.formatDate(this.tanggal_mulai)+"&tanggal_selesai="+this.formatDate(this.tanggal_selesai)).then(result => {
                    if(result.data.code == '00') {
                        alert('failed get Produk')
                    }
                    else {
                        this.produkList = result.data.detail.data;
                        this.totalRow = result.data.detail.totalRow;
                        this.last = Math.ceil(this.totalRow / this.perPage)
                        this.pagination = this.getPaging();
                    }
                    this.$root.is_loading = false;
                }, error => {
                    this.$root.is_loading = false;
                    console.log('gk ok')
                    context.errors = errors;
                });
            }
            
        },
        goTo: function(paths) {
            this.$router.push({ path : paths })
            var $path = window.location.href.split('/');
            this.isActive = this.$route.path;
            // this.$router.go();
        },
        getPaging: function() {
            var i;
            var paging = []
            if(this.page > this.first+2){
                this.first = this.page-3
            }else if(this.page == this.first && this.first != 1){
                this.first = this.page-3
                if(this.first < 1){
                    this.first = 1
                }
            }
            for(i = this.first;i < 6+this.first && i <= this.last; i++){
                paging.push(i)
            }
            return paging;
        },
        tableTo: function(page){
            this.page = page
            this.init();
        },
        goDetailTransaksi: function(id_transaksi,type){
            var u = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
            this.$router.push({ path : '/pembelian/list/pembayaran-pembelian-detail/'+id_transaksi+'/'+type })
            var $path = window.location.href.split('/');
            this.isActive = this.$route.path;
        },
        goDetailProduk: function(id_produk) {
            this.$router.push({ path : '/produk/produk-detail/'+id_produk })
        },
        currencyFormat: function(val){
            return this.$parent.currencyFormat(val)
        },
        statusBayarCallback: function(val) {
            if(val == 1){
                return '<span style="color:green;">Dibayar</span>'
            }else{
                return '<span style="color:red;">Belum Dibayar</span>'
            }
        },
        statusCallback: function(val) {
            if(val == 1){
                return '<span style="color:green;">Dibayar</span>'
            }else{
                return '<span style="color:red;">Belum Dibayar</span>'
            }
        },
        setFilter: function() {
            this.init();
        },
        showModalPayment: function() {
            this.$modal.show('make-payment');
        },
        hideModalPayment: function() {
            this.$modal.hide('make-payment');
        },
        formatDate(date) {
            if(date != ''){
                var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

                if (month.length < 2) month = '0' + month;
                if (day.length < 2) day = '0' + day;

                return [year, month, day].join('-');
            }else {
                return ''
            }
        },
    },
    components : {
        'rincian-table' : RincianTable
    }
}
</script>


// WEBPACK FOOTER //
// src/components/laporan/Produk.vue